module.exports = __webpack_public_path__ + "static/media/Wilmington.5b3ee30e.jpg";